import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'

import useOnClickOutside from '@hooks/useOnClickOutside'
import { useQueryParams } from '@hooks/useQueryParams'
import { useWindowSize } from '@hooks/useWindowSize'

import type { ScheduleTypeSwitcherProps } from './ScheduleTypeSwitcher.props'

export function ScheduleTypeSwitcher({ ...props }: ScheduleTypeSwitcherProps) {
  const ref = useRef(null)

  const { getQuery, setQuery } = useQueryParams()
  const { width } = useWindowSize()

  const [isShowMobile, setIsShowMobile] = useState(false)

  const handleSetRange = (type: string) => {
    if (width < 992) {
      getQuery('range') === type
        ? setIsShowMobile((p) => !p)
        : (() => {
            setQuery('range', type)
            setIsShowMobile(false)
          })()
    } else {
      setQuery('range', type)
    }
  }

  useEffect(() => {
    if (!getQuery('range')) setQuery('range', 'day')
  }, [])

  useOnClickOutside(ref, () => width < 992 && setIsShowMobile(false))

  return (
    <div
      ref={ref}
      className={classNames('header__schedule-tabs schedule-tabs', { '--isShow': isShowMobile })}
    >
      <button
        type="button"
        className={classNames('schedule-tabs__button schedule__btn-day', { 'schedule-tabs__button--active': getQuery('range') === 'day' || !getQuery('range') })}
        onClick={() => handleSetRange('day')}
      >
        День
      </button>
      <button
        type="button"
        className={classNames('schedule-tabs__button schedule__btn-week', { 'schedule-tabs__button--active': getQuery('range') === 'week' })}
        onClick={() => handleSetRange('week')}
      >
        Тиждень
      </button>
      <button
        type="button"
        className={classNames('schedule-tabs__button schedule__btn-month', { 'schedule-tabs__button--active': getQuery('range') === 'month' })}
        onClick={() => handleSetRange('month')}
      >
        Місяць
      </button>
    </div>
  )
}
